const normalizeTin = (tin) => {
  if (tin == null || String(tin).trim() === '') {
    return null;
  }
  return String(tin).trim().toLowerCase();
};

const buildEndpointKey = (endpointSchemeId, endpointId) => {
  if (
    endpointSchemeId == null ||
    String(endpointSchemeId).trim() === '' ||
    endpointId == null ||
    String(endpointId).trim() === ''
  ) {
    return null;
  }
  return `${String(endpointSchemeId).trim()}:${String(endpointId).trim()}`;
};

const hasMatchingTin = (supplierParty, customerParty) => {
  const supplierTin = normalizeTin(supplierParty?.tin);
  const customerTin = normalizeTin(customerParty?.tin);

  if (supplierTin == null || customerTin == null) {
    return false;
  }

  return supplierTin === customerTin;
};

const hasMatchingEndpoint = (supplierParty, customerParty) => {
  const supplierEndpoint = buildEndpointKey(supplierParty?.endpoint_scheme_id, supplierParty?.endpoint_id);
  const customerEndpoint = buildEndpointKey(customerParty?.endpoint_scheme_id, customerParty?.endpoint_id);

  if (supplierEndpoint == null || customerEndpoint == null) {
    return false;
  }

  return supplierEndpoint === customerEndpoint;
};

export const partiesAreSame = (supplierParty, customerParty) => {
  if (supplierParty == null || customerParty == null) {
    return false;
  }

  return hasMatchingTin(supplierParty, customerParty) || hasMatchingEndpoint(supplierParty, customerParty);
};

export const sellerBuyerDistinctnessTest = () =>
  function sellerBuyerDistinctness(value) {
    const supplier = this.path === 'accounting_supplier_party' ? value : this.parent?.accounting_supplier_party;
    const customer = this.path === 'accounting_customer_party' ? value : this.parent?.accounting_customer_party;

    return !partiesAreSame(supplier, customer);
  };
